import { Injectable } from '@angular/core';
import { CreateStudentRequest, DeleteStudentRequest, UpdateStudentData } from '../models/student-data.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentService {

  private apiUrl = `${environment.sgcApi}`;
  private studentRoute = 'student';

  constructor(
    private httpClient: HttpClient
  ) {}

  addStudent(createStudentRequest: CreateStudentRequest, user) : Observable<number> {
    let endpoint = `${this.apiUrl}${this.studentRoute}/user/${user}`;
    return this.httpClient.post<number>(endpoint, JSON.stringify(createStudentRequest))
      .pipe(map((data) => data));
  }

  updateStudent(updateStudentData: UpdateStudentData, user: string) {
    let endpoint = `${this.apiUrl}${this.studentRoute}/user/${user}`;
    return this.httpClient.put(endpoint, JSON.stringify(updateStudentData));
  }

  deleteStudent(deleteStudentRequest: DeleteStudentRequest, user: string) {
    let endpoint = `${this.apiUrl}${this.studentRoute}/user/${user}/delete`;
    return this.httpClient.put(endpoint, JSON.stringify(deleteStudentRequest));
  }
}
